export var ErrorCode;
(function (ErrorCode) {
    ErrorCode["NETWORK_ERROR"] = "NETWORK_ERROR";
    ErrorCode["UNAUTHORIZED"] = "UNAUTHORIZED";
    ErrorCode["FORBIDDEN"] = "FORBIDDEN";
    ErrorCode["NOT_FOUND"] = "NOT_FOUND";
    ErrorCode["VALIDATION_ERROR"] = "VALIDATION_ERROR";
    ErrorCode["INTERNAL_SERVER_ERROR"] = "INTERNAL_SERVER_ERROR";
    ErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    ErrorCode["BAD_REQUEST"] = "BAD_REQUEST";
    ErrorCode["TIMEOUT"] = "TIMEOUT";
    // Auth specific
    ErrorCode["INVALID_CREDENTIALS"] = "INVALID_CREDENTIALS";
    ErrorCode["USER_NOT_FOUND"] = "USER_NOT_FOUND";
    ErrorCode["EMAIL_ALREADY_EXISTS"] = "EMAIL_ALREADY_EXISTS";
    ErrorCode["ACCOUNT_LOCKED"] = "ACCOUNT_LOCKED";
    ErrorCode["SESSION_EXPIRED"] = "SESSION_EXPIRED";
    ErrorCode["INVALID_OTP"] = "INVALID_OTP";
    ErrorCode["OTP_EXPIRED"] = "OTP_EXPIRED";
})(ErrorCode || (ErrorCode = {}));
export class AppError extends Error {
    code;
    originalError;
    context;
    isOperational;
    constructor(message, options = {}) {
        super(message);
        this.name = "AppError";
        this.code = options.code || ErrorCode.UNKNOWN_ERROR;
        this.originalError = options.originalError;
        this.context = options.context;
        // Operational errors are expected errors (e.g. validation), non-operational are bugs
        this.isOperational = options.isOperational ?? true;
        // Capture stack trace
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, AppError);
        }
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            code: this.code,
            context: this.context,
            isOperational: this.isOperational,
        };
    }
}
export const isAppError = (error) => {
    return error instanceof AppError;
};
